var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useState, } from "react";
import { useSelector } from "react-redux";
// components
import PurchaseFee from "../PurchaseFee";
import FileUploadComponent from "../FileUploadComponent";
import PaymentMode from "../PaymentMode";
import AccordionComponent from "../AccordionComponent";
import InputComponent from "../InputComponent";
import FolioSelector from "../FolioSelector";
import ClientDetails from "../ClientDetails";
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import { ONE_THOUSAND_CRORE_RUPEE, ONE_LAKH_RUPEE } from "../../constants";
import { formatIndiaNumber } from "../../utils";
var TopupComponent = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var setLeadId = _a.setLeadId, setIsCxoButtonEnabled = _a.setIsCxoButtonEnabled;
    var profileData = useSelector(function (state) {
        return state.Profile.ProfileDetails.reducersData.data.profileDetails;
    });
    var _j = __read(useState(false), 2), inValidAmount = _j[0], setInValidAmount = _j[1];
    var _k = useSelector(function (state) { return state.markets.AifPms; }), subCategoryId = _k.subCategoryId, clientDetails = _k.clientDetails, watchListData = _k.watchListData, draftOrderDetails = _k.draftOrderDetails;
    var folioDetails = useSelector(function (state) { return state.markets.global; }).folioDetails;
    var paymentProcess = useSelector(function (state) { return state.markets.payment; });
    var selectLoginSearchData = useSelector(function (state) { return state.markets.leadservice; }).selectLoginSearchData;
    var topup = useSelector(function (state) { return state.markets.payment; }).topup;
    useEffect(function () {
        var _a, _b, _c;
        if (((_a = folioDetails === null || folioDetails === void 0 ? void 0 : folioDetails.data) === null || _a === void 0 ? void 0 : _a.length) > 0 && topup.folio == "") {
            var item = (_b = folioDetails === null || folioDetails === void 0 ? void 0 : folioDetails.data) === null || _b === void 0 ? void 0 : _b[0];
            handleSelectFolio({
                units: item.totalqty,
                number: item.foliono,
                amount: (_c = item.marketvalue) === null || _c === void 0 ? void 0 : _c.toFixed(2),
            });
        }
    }, [folioDetails]);
    useEffect(function () {
        aifPmsDi.global.folioDetails({
            categoryCode: subCategoryId,
            ucccode: clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.ucccode,
            schemeId: watchListData === null || watchListData === void 0 ? void 0 : watchListData.schemeId,
        });
    }, []);
    var handleSelectFolio = useCallback(function (folio) {
        var updatedValues = __assign(__assign({}, paymentProcess.topup), { folio: folio.number, totalqty: folio.units, marketvalue: Number(folio.amount) });
        aifPmsDi.payment.updateTopupValues(updatedValues);
    }, [paymentProcess.topup]);
    var onChangeAmount = useCallback(function (event) {
        var value = event.target.value;
        var formattedValue = value.replace(/,/g, "");
        var newValue = formatIndiaNumber(formattedValue);
        var numericValue = Number(value === null || value === void 0 ? void 0 : value.split(",").join(""));
        if (numericValue < ONE_LAKH_RUPEE) {
            setInValidAmount(true);
        }
        else {
            setInValidAmount(false);
        }
        var updatedValues = __assign(__assign({}, paymentProcess.topup), { amount: newValue });
        if (numericValue <= ONE_THOUSAND_CRORE_RUPEE) {
            aifPmsDi.payment.updateTopupValues(updatedValues);
        }
    }, [paymentProcess]);
    var handleKeyPress = function (event) {
        var charCode = event.charCode || event.keyCode;
        if ((charCode >= 48 && charCode <= 57) || charCode === 44) {
            return true;
        }
        event.preventDefault();
    };
    return (React.createElement("div", { className: "rounded auto-height width-375 position-relative " },
        React.createElement("div", { className: "bg-white px-3 py-4-custom rounded box-shadow-light ger-sheme" },
            React.createElement(ClientDetails, { setIsCxoButtonEnabled: setIsCxoButtonEnabled, setLeadId: setLeadId }),
            React.createElement("form", { className: "p-top-20 form" },
                (((profileData === null || profileData === void 0 ? void 0 : profileData.isCxo) && (selectLoginSearchData === null || selectLoginSearchData === void 0 ? void 0 : selectLoginSearchData.display_name)) ||
                    ((profileData === null || profileData === void 0 ? void 0 : profileData.isCxo) && ((_b = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _b === void 0 ? void 0 : _b.trempcode)) ||
                    (clientDetails &&
                        (clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.ispansearch) !== "true" &&
                        (profileData === null || profileData === void 0 ? void 0 : profileData.isCxo) &&
                        draftOrderDetails &&
                        Object.keys(draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data).length == 0)) && (React.createElement("p", { className: "txt_medium-gray DMSanN_14_300 fw-300" },
                    "Login for:",
                    " ",
                    (selectLoginSearchData === null || selectLoginSearchData === void 0 ? void 0 : selectLoginSearchData.display_name)
                        ? selectLoginSearchData === null || selectLoginSearchData === void 0 ? void 0 : selectLoginSearchData.display_name
                        : ((_c = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _c === void 0 ? void 0 : _c.trempcode)
                            ? "".concat((_d = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _d === void 0 ? void 0 : _d.trempname, " (").concat((_e = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _e === void 0 ? void 0 : _e.trempcode, ")")
                            : "")),
                React.createElement(InputComponent, { label: "Amount", placeholder: "Enter amount here", helperText: "", name: "amount", required: true, onChangeEvent: onChangeAmount, value: (_f = paymentProcess === null || paymentProcess === void 0 ? void 0 : paymentProcess.topup) === null || _f === void 0 ? void 0 : _f.amount, 
                    //@ts-ignore
                    onKeyPress: handleKeyPress, minAmount: 100000, isInvalid: inValidAmount }),
                React.createElement("div", { className: "d-flex align-items-start gap-2 new-mandate-section" },
                    React.createElement("div", { className: "w-100 dropdown-container" },
                        React.createElement("div", { className: "mandate-bank-select w-100" },
                            React.createElement("form", { className: "form" },
                                React.createElement(FolioSelector, { folios: (_g = folioDetails === null || folioDetails === void 0 ? void 0 : folioDetails.data) === null || _g === void 0 ? void 0 : _g.map(function (item) {
                                        return {
                                            units: item.totalqty,
                                            number: item.foliono,
                                            amount: String(item.marketvalue),
                                        };
                                    }), selectedFolio: (_h = paymentProcess === null || paymentProcess === void 0 ? void 0 : paymentProcess.topup) === null || _h === void 0 ? void 0 : _h.folio, onSelect: handleSelectFolio }))))),
                React.createElement(PaymentMode, null))),
        React.createElement(AccordionComponent, { items: [
                {
                    header: "Set Purchase Fees & Charges",
                    body: React.createElement(PurchaseFee, null),
                    optional: true,
                    leftIcon: "edel-icon-bars",
                },
                {
                    header: "Upload Declaration",
                    body: (React.createElement(React.Fragment, null,
                        React.createElement(FileUploadComponent, { fileSize: 5 }))),
                    optional: false,
                    leftIcon: "edel-icon-medal-bookmark",
                },
            ] })));
};
export default TopupComponent;
